module.exports = __webpack_public_path__ + "img/transaction.d605443c.svg";